import { REG_PATH_KEYS } from '$lib/utils/constants';
import { shouldUse1_0PostAuthPath } from '$lib/utils/aofl-accounts';
import { get } from 'svelte/store';
import { user } from '$lib/stores/user/store';
import { experimentService } from '$lib/services/experiments/client';
import { ACTIVE_EXPERIMENTS, EXPERIMENT_KEYS } from '$lib/services/experiments/client/constants';

/**
 *  @type {{[key: string]: import('$lib/utils/page').PageCondition}} conditions - The conditions object containing the conditions to be resolved.
 */
const pageConditions = {
	browserIOSAltPayment1_0Subscriber: {
		condition: async () => {
			return (
				get(user)?.userMetaData?.subscription_path === REG_PATH_KEYS.IOS_ALT_PAYMENT_SUBSCRIBER_1_0
			);
		},
		resolve: async () => await import('../_browser/Page.svelte'),
	},
	browser1_0_User: {
		condition: async () => {
			return shouldUse1_0PostAuthPath();
		},
		resolve: async () => await import('../_browser/Page.svelte'),
	},
	browser_2_0_rebrand_redesign: {
		condition: async () => {
			const { experimentKey, variants } = ACTIVE_EXPERIMENTS.ABCM2_AA_OFFER_REDESIGN;
			await experimentService.initializeExperiments([...EXPERIMENT_KEYS, experimentKey]);

			const assignedVariant = await experimentService.getExperimentArm(experimentKey, {
				page_name: 'aa-offer',
				page_url: '/abc/aa-offer',
			});

			return assignedVariant === variants.test;
		},
		resolve: async () => await import('../_browser-2-0-rebrand-redesign/Page.svelte'),
	},
	default: {
		condition: async () => true,
		resolve: async () => await import('../_browser-2-0-rebrand/Page.svelte'),
	},
};

export { pageConditions };
